import { useAutoScrollOnLoad } from "../../hooks/autoScrollOnLoad";

export default function BrochurePage() {

    useAutoScrollOnLoad()

    return (
        <>
            <h1>Brochure</h1>
        </>
    );
}